'use client';

import { useMetaAttributionCookies } from '@/hooks/useMetaAttributionCookies';

export function MetaAttributionCookies() {
  useMetaAttributionCookies({
    alsoFixFbp: true,
    markerTtlSeconds: 7 * 24 * 60 * 60, // 7 days
    oneDaySeconds: 24 * 60 * 60, // 1 day
    sameSite: 'Lax',
    secure: true,
    debug: false,
  });

  return null;
}
